"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const HelpIconology_vue_1 = __importDefault(require("@/client/components/help/HelpIconology.vue"));
const HelpPhases_vue_1 = __importDefault(require("@/client/components/help/HelpPhases.vue"));
const HelpHotkeys_vue_1 = __importDefault(require("@/client/components/help/HelpHotkeys.vue"));
const HelpRulebooks_vue_1 = __importDefault(require("@/client/components/help/HelpRulebooks.vue"));
const HelpStandardProjects_vue_1 = __importDefault(require("@/client/components/help/HelpStandardProjects.vue"));
const TABS = ['iconology', 'standard-projects', 'phases', 'hotkeys', 'rulebooks'];
exports.default = (0, vue_1.defineComponent)({
    name: 'Help',
    data() {
        return {
            currentPage: 'iconology',
        };
    },
    components: {
        HelpIconology: HelpIconology_vue_1.default,
        HelpPhases: HelpPhases_vue_1.default,
        HelpRulebooks: HelpRulebooks_vue_1.default,
        HelpStandardProjects: HelpStandardProjects_vue_1.default,
        HelpHotkeys: HelpHotkeys_vue_1.default,
    },
    mounted() {
        const hash = window.location.hash.replace('#', '');
        if (TABS.includes(hash)) {
            this.currentPage = hash;
        }
    },
    watch: {
        currentPage(newTab) {
            window.location.hash = newTab;
        },
    },
    methods: {
        setTab(tab) {
            this.currentPage = tab;
        },
        isOpen(tab) {
            return tab === this.currentPage;
        },
    },
});
